import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";
import { RemoveClient } from "@domain/models/RemoveClient";
import { Report } from "@domain/models/Report";
import { RemoveJob } from "@domain/models/RemoveJob";

type Input = {
  result: Report["result"];
  description: string;
  selectedClients: RemoveClient[];
  notSelectedClients: RemoveClient[];
};

type Output = Promise<RemoveJob>;

export class RemoveClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly httpRemoveRepository: RemoveRepository) {}

  execute({ result, description, selectedClients, notSelectedClients }: Input) {
    return this.httpRemoveRepository.removeClients(
      result,
      description,
      selectedClients,
      notSelectedClients
    );
  }
}
